import companiesApi from "@/api/companies";
const state = {
    isCustomerEmailRequired: false
};
const actions = {
    async getCompanyInfo(context) {
        const response = await companiesApi.getInfo();
        context.commit("setCompanyInfo", response);
    }
};
const getters = {
    isCustomerEmailRequired(state) {
        return state.isCustomerEmailRequired;
    }
};
const mutations = {
    setCompanyInfo(state, companyInfo) {
        state.isCustomerEmailRequired = companyInfo?.isCustomerEmailRequired ?? false;
    }
};
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
